<template>
  <footer class="cm-footer py-5">
    <div class="footer-container w-100">
      <div class="footer-columns">
        <div class="footer-column" v-for="(column, colIndex) in columns" :key="colIndex">
          <div v-for="(menu, menuIndex) in column" :key="menuIndex">
            <h3 v-if="menu.title">{{ menu.title }}</h3>
            <ul>
              <li v-for="(link, idx) in menu.submenus" :key="idx">
                <a :href="link.url" :target="link.target">{{ link.title }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <hr class="divider">
        <div class="footer-text">
          © BICE 2025. Todos los derechos reservados
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";

export default {
  name: 'AppFooter',
  data() {
    return {
      footerMenu: [],
      columns: []
    }
  },
  created() {
    this.fetchFooterMenu();
  },
  methods: {
    fetchFooterMenu() {
      axios.get(`${process.env.VUE_APP_API_URL}/menus/api_footer_menu_vue`)
        .then(response => {
          const footerMenuData = response.data[0];

          if (footerMenuData && footerMenuData.submenus) {
            this.footerMenu = footerMenuData.submenus;
            this.processFooterMenu();
          } else {
            this.footerMenu = [];
            this.columns = [];
          }
        })
        .catch(error => {
          console.error('Error fetching footer menu:', error);
        });
    },
    processFooterMenu() {
      let columns = [];
      let currentColumn = [];
      let submenuCount = 0;
      const maxSubmenusPerColumn = 9;

      let i = 0;
      while (i < this.footerMenu.length) {
        let level2Menu = this.footerMenu[i];
        let totalItems = level2Menu.submenus.length + 1;

        if (totalItems > maxSubmenusPerColumn) {
          let submenus = level2Menu.submenus;
          let chunks = [];

          for (let j = 0; j < submenus.length; j += (maxSubmenusPerColumn - 1)) {
            chunks.push(submenus.slice(j, j + (maxSubmenusPerColumn - 1)));
          }

          for (let k = 0; k < chunks.length; k++) {
            let menuChunk = {
              title: k === 0 ? level2Menu.title : '',
              submenus: chunks[k],
            };

            let chunkTotalItems = menuChunk.submenus.length + (menuChunk.title ? 1 : 0);

            if (submenuCount + chunkTotalItems <= maxSubmenusPerColumn) {
              currentColumn.push(menuChunk);
              submenuCount += chunkTotalItems;
            } else {
              if (currentColumn.length > 0) {
                columns.push(currentColumn);
              }
              currentColumn = [];
              submenuCount = 0;

              currentColumn.push(menuChunk);
              submenuCount += chunkTotalItems;
            }
          }
        } else {
          if (submenuCount + totalItems <= maxSubmenusPerColumn) {
            currentColumn.push(level2Menu);
            submenuCount += totalItems;
          } else {
            if (currentColumn.length > 0) {
              columns.push(currentColumn);
            }
            currentColumn = [];
            submenuCount = 0;

            currentColumn.push(level2Menu);
            submenuCount += totalItems;
          }
        }
        i++;
      }

      if (currentColumn.length > 0) {
        columns.push(currentColumn);
      }

      this.columns = columns;
    }
  }
}
</script>

<style scoped>
.cm-footer {
  background-color: #313D48;
  color: #fff;
  padding: 20px 0;
}

.footer-container {
  margin: 0 auto;
}

.footer-columns {
  display: flex;
  flex-wrap: wrap;
}

.footer-column {
  flex: 1 1 25%;
  max-width: 25%;
  box-sizing: border-box;
  padding: 0 10px;
}

.footer-column h3 {
  font-size: 18px;
  font-weight: 600;
  color: #A1D784;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column li {
  margin-bottom: 10px;
}

.footer-column a {
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  word-wrap: break-word;
}

.footer-bottom {
  margin-top: 20px;
  text-align: center;
}

.divider {
  border: none;
  border-top: 1px solid #919199;
  margin: 20px 0;
}

@media (max-width: 768px) {
  .footer-column {
    flex: 1 1 50%;
    max-width: 50%;
  }
}

@media (max-width: 600px) {
  .footer-column {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

@media (max-width: 960px) {
  .footer-container {
    padding: 0px 5%;
  }
}
</style>
